import {useAppSelector} from '@/hooks';
import {useIsCurrentPageVideo} from '@Hooks/poster-editor/useIsCurrentPageVideo';

export const useIsTimelineButtonVisible = (): boolean => {
  const isCurrentPageVideo = useIsCurrentPageVideo();
  const isTimelineModeOn = useAppSelector((state) => {
    return state.posterEditor.isTimelineModeOn;
  });
  const isVersionHistoryModeActive = useAppSelector((state) => {
    return state.posterEditor.isVersionHistoryModeActive;
  });

  return isCurrentPageVideo && !isTimelineModeOn && !isVersionHistoryModeActive;
};
